<template>
  <carousel-3d :perspective="20" :width="600" :height="500" :minSwipeDistance="0" :space="1000">
    <slide v-for="(slide, i) in slides" :index="i" :key="i">
      <template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
        <div
          v-animate.repeat.fade="'slide-up'"
          :data-index="index"
          :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }"
        >
          <h1 class="quoteTitle">{{slide.quote}}</h1>
          <h1 class="quoteName">{{slide.name}}</h1>
          <h1 class="quoteSubName">{{slide.title}}</h1>
        </div>
      </template>
    </slide>
  </carousel-3d>
</template>
<script>
import { Carousel3d, Slide } from "vue-carousel-3d";
export default {
  components: {
    Carousel3d,
    Slide
  },
  props: ["slides"]
};
</script>

<style lang="scss">
@import "./Carousel.scss";
</style>